module.exports = __webpack_public_path__ + "img/clock (4).50d6c3a9.svg";